module.exports = __webpack_public_path__ + "assets/img/ND.3efe6f94.png";